<app-base-notification [base]="base">
  <div clickToRelativeUrl [innerHTML]="'notifications.vacation_reminder.text' | customLocale: {
    'begin_at': params.vacation_begin_at | date: 'dd MMMM':'': langCode,
    'end_at': params.vacation_end_at | date: 'dd MMMM':'': langCode
  }"></div>
</app-base-notification>

